import React from 'react';
import PropTypes from 'prop-types';
import CustomSwitch from '../custom-switch/custom-switch';
import BesicTable from '../table/basicTable';
import Pagination from '../pagination/pagination';
import Button from '../button/button';
import { NextIcon, PrevIcon, BorderedBoxIcon } from '../icons/icons';
import SwitchGroup from '../switch-group/switch-group';
import TextBoxGroup from '../text-box-group/text-box-group';
import {
  handlePrdPkgChange,
  isGrossWtInvalid,
  getBach,
} from './buyer-booking-tabs/buyerHelper';
import Action from '../action/action';
import PaginationLoader from '../pagination/loader';
import ConsoleBookingLoader from './buyer-booking-tabs/console-booking-loader';
import NoData from '../no-data/no-data';

function ConsoleBooking({ consoleprops }) {
  const {
    t,
    setVendorPackageButton,
    vendorPackageButton,
    supplierTab,
    consoleBookingColumnsUpdate,
    tableData,
    pageNumber,
    totalData,
    perPageC,
    swicthPage,
    setSupplierTab,
    totalPage,
    // packageOptions,
    consolePackageData,
    setConsolePackageData,
    handlConsolePackageTabSwitch,
    setTabDetails,
    isConsoleLoading,
    bookingData,
    originalQtys,
  } = consoleprops;

  const isErrorPackage =
    !tableData.some((item) => item?.package?.value) ||
    tableData.some((item) => {
      const original = originalQtys.find((o) => o._id === item._id);
      return (
        item.shippedQty === '' ||
        Number(item.shippedQty) > Number(original?.shippedQty ?? 0)
      );
    });

  const validatePackages = () => {
    const isPackageValid = (pkg) => {
      const { quantity, length, width, height, grossWeight, measurementUnit } =
        pkg;

      return (
        quantity && length && width && height && grossWeight && measurementUnit
      );
    };

    const isValid = consolePackageData
      .filter((pkg) =>
        pkg.package.value !== 'Default Package'
          ? pkg?.selectedProduct?.length
          : false
      )
      .every((pkg) => isPackageValid(pkg));

    return isValid;
  };

  return (
    <>
      {supplierTab === 'product' && (
        <div className="supplier-booking-content">
          <div className="d-flex align-center pt-5 justify-between">
            <h3 className="mt-20">
              {t('manageordersscreen.sendbookingdetails.descriptionconsole')}
            </h3>
            {false && (
              <div className="d-flex align-center">
                <label className="pickup-label">
                  {t('manageordersscreen.sendbookingdetails.vendorbooking')}
                </label>
                <CustomSwitch
                  className="pickup-switch"
                  onChange={(e) => {
                    setVendorPackageButton(e?.target?.checked);
                  }}
                  checked={vendorPackageButton}
                />
              </div>
            )}
          </div>
          {isConsoleLoading && <ConsoleBookingLoader />}
          {!isConsoleLoading && bookingData.length > 0 && (
            <BesicTable
              columns={consoleBookingColumnsUpdate}
              data={tableData.filter((data) => data.pageNumberC === pageNumber)}
              className="supplier-booking auto-column-width"
            />
          )}
          {!isConsoleLoading && bookingData.length === 0 && <NoData />}
          {/* Pagination Loader or Pagination */}
          {isConsoleLoading && <PaginationLoader />}
          {!isConsoleLoading && bookingData.length > 0 && (
            <Pagination
              paginationData={totalPage}
              currentPage={pageNumber}
              totalData={totalData}
              perPage={perPageC}
              swicthPage={(page) => {
                swicthPage(page);
              }}
              style={{ zIndex: '8' }}
              className="mb-30"
            />
          )}

          {/*  <div className="supplier-booking-button-area mt-20">
                <Button
                  label={t(
                    'manageordersscreen.sendbookingdetails.addpackagedetailsbtn.clear'
                  )}
                  styles="cancel"
                  size="large"
                  onClick={() => {}}
                />
                <Button
                  label={t(
                    'manageordersscreen.sendbookingdetails.addpackagedetailsbtn.title'
                  )}
                  styles="submit"
                  size="large"
                  className="ml-20"
                  onClick={() => {}}
                />
              </div> */}
          {!isConsoleLoading && bookingData.length > 0 && (
            <div className="d-flex justify-end w-100">
              <Button
                label={t(
                  'manageordersscreen.createbookingmenu.confirmentities.next'
                )}
                styles="submit"
                size="large"
                iconRight={<NextIcon />}
                onClick={() => {
                  handlConsolePackageTabSwitch();
                }}
                spacing="0.694vw"
                className="px-24"
                disabled={isErrorPackage}
              />
            </div>
          )}
        </div>
      )}

      {supplierTab === 'package details console' && (
        <div className="supplier-booking-content ask-qut">
          <h3>{t('manageordersscreen.packagingdetails.goodsinformation')}</h3>

          <div className="package-details-outerwrapper">
            <div className="d-flex justify-between">
              <h3 className="m-0">
                {t('manageordersscreen.packagingdetails.createpackages')}
              </h3>
            </div>

            {consolePackageData?.map((pkg) =>
              pkg?.selectedProduct?.length ? (
                <div className="package-details-wrapper">
                  <div className="package-details-card multiple">
                    <div className="heading">
                      <div className="left">
                        <span className="card-icon">
                          <BorderedBoxIcon />
                        </span>

                        <h4>{pkg?.package?.label} </h4>
                        <table>
                          <tr>
                            <td />
                          </tr>
                        </table>

                        <SwitchGroup
                          name="measurementUnit"
                          defaultSelected={0}
                          onChange={(e) => {
                            handlePrdPkgChange(
                              e,
                              pkg?.id,
                              setConsolePackageData
                            );
                          }}
                          disabled={pkg?.package?.value === 'Default Package'}
                        >
                          <span
                            className={
                              pkg?.measurementUnit === 'metric'
                                ? ''
                                : 'inactive'
                            }
                          >
                            {t('manageordersscreen.packagingdetails.metric')}
                          </span>
                          <span
                            className={
                              pkg?.measurementUnit === 'imperial'
                                ? ''
                                : 'inactive'
                            }
                          >
                            {t('manageordersscreen.packagingdetails.imperial')}
                          </span>
                        </SwitchGroup>
                      </div>
                    </div>
                    <div className="body">
                      <table>
                        <thead>
                          <tr>
                            {[
                              'quantity',
                              'length',
                              'width',
                              'height',
                              'grossWeight',
                              'products',
                            ].map((field) => (
                              <th>
                                {t(
                                  `manageordersscreen.packagingdetails.${field}`
                                )}
                                {pkg?.name !== 'Default Package' && (
                                  <span className="required">*</span>
                                )}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            {[
                              'quantity',
                              'length',
                              'width',
                              'height',
                              'grossWeight',
                            ].map((field) => (
                              <td key={field}>
                                <TextBoxGroup
                                  id={field}
                                  name={field}
                                  type="number"
                                  placeholder={
                                    field === 'grossWeight'
                                      ? 'GW Wt'
                                      : t(
                                          `manageordersscreen.packagingdetails.${field}`
                                        )
                                  }
                                  bach={getBach(pkg, field)}
                                  onChange={(e) =>
                                    handlePrdPkgChange(
                                      e,
                                      pkg?.id,
                                      setConsolePackageData
                                    )
                                  }
                                  value={
                                    // check if 'Default Package' needs to diaplay and what abt dimensions?
                                    pkg?.name === 'Default Package'
                                      ? ''
                                      : pkg?.[field] || ''
                                  }
                                  onPaste={(e) => {
                                    e.preventDefault(); // Prevent the default paste action
                                    const pastedValue =
                                      e.clipboardData.getData('text');
                                    if (/^\d*\.?\d*$/.test(pastedValue)) {
                                      const [integerPart, decimalPart] =
                                        pastedValue.split('.');
                                      const sanitizedValue = decimalPart
                                        ? `${integerPart}.${decimalPart.slice(
                                            0,
                                            2
                                          )}`
                                        : integerPart;
                                      e.target.value =
                                        field === 'quantity'
                                          ? integerPart
                                          : sanitizedValue;
                                      e.target.dispatchEvent(
                                        new Event('input', { bubbles: true })
                                      ); // Trigger React change
                                      handlePrdPkgChange(
                                        e,
                                        pkg?.id,
                                        setConsolePackageData
                                      );
                                    }
                                  }}
                                  errorMessage={
                                    field === 'grossWeight' &&
                                    pkg?.grossWeight &&
                                    isGrossWtInvalid(pkg, '') &&
                                    t(
                                      'manageordersscreen.packagingdetails.grossWtMsg'
                                    )
                                  }
                                  disabled={
                                    pkg?.package?.value === 'Default Package'
                                  }
                                />
                              </td>
                            ))}
                            <td>
                              <Action
                                label={
                                  pkg?.selectedProduct?.length
                                    ? `${pkg?.selectedProduct?.length} ${
                                        pkg?.selectedProduct?.length > 1
                                          ? t(
                                              'manageordersscreen.sendbookingdetails.addpackagedetailsbtn.productsplaceholder'
                                            )
                                          : t(
                                              'manageordersscreen.sendbookingdetails.addpackagedetailsbtn.productplaceholder'
                                            )
                                      }`
                                    : t(
                                        'manageordersscreen.sendbookingdetails.addpackagedetailsbtn.productsplaceholdernopackage'
                                      )
                                }
                                className="select-box"
                                required
                              >
                                {pkg?.selectedProduct?.map((child) => {
                                  return (
                                    <li>
                                      <center>{child?.partName}</center>
                                    </li>
                                  );
                                })}

                                {/*     <p className="popover-small-text">
                                  {t(
                                    'manageordersscreen.packagingdetails.cantfindproduct'
                                  )}{' '}
                                  {t(
                                    'manageordersscreen.packagingdetails.dontworry'
                                  )}{' '}
                                  <button
                                    type="button"
                                    onClick={() =>
                                      setSupplierTab('product details')
                                    }
                                  >
                                    {t(
                                      'manageordersscreen.packagingdetails.previousStep'
                                    )}
                                  </button>
                                </p> */}
                              </Action>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              ) : null
            )}
          </div>

          <div className="supplier-booking-button-area justify-between mt-10">
            <Button
              label={t(
                'manageordersscreen.createbookingmenu.confirmentities.back'
              )}
              styles="back"
              size="large"
              icon={<PrevIcon />}
              spacing="0.694vw"
              className="px-24"
              onClick={() => {
                setSupplierTab('product');
              }}
            />
            <Button
              label={t(
                'manageordersscreen.createbookingmenu.confirmentities.next'
              )}
              styles="submit"
              size="large"
              onClick={() => {
                if (validatePackages()) {
                  setTabDetails((prev) => {
                    const updatedTabDetails = { ...prev };
                    updatedTabDetails.packagedetailsconsole = true;
                    return updatedTabDetails;
                  });
                  setSupplierTab('shipment details');
                }
              }}
              disabled={!validatePackages()}
              iconRight={<NextIcon />}
              spacing="0.694vw"
              className="px-24"
            />
          </div>
        </div>
      )}
    </>
  );
}

export default React.memo(ConsoleBooking);
ConsoleBooking.propTypes = {
  consoleprops: PropTypes.shape({
    t: PropTypes.func,
    setVendorPackageButton: PropTypes.func,
    vendorPackageButton: PropTypes.bool,
    supplierTab: PropTypes.string,
    consoleBookingColumnsUpdate: PropTypes.instanceOf(Array),
    tableData: PropTypes.instanceOf(Array),
    pageNumber: PropTypes.string,
    totalData: PropTypes.string,
    perPageC: PropTypes.string,
    swicthPage: PropTypes.func,
    setSupplierTab: PropTypes.func,
    setSelectedVendorType: PropTypes.func,
    totalPage: PropTypes.string,
    packageOptions: PropTypes.instanceOf(Array),
    consolePackageData: PropTypes.instanceOf(Array),
    setConsolePackageData: PropTypes.func,
    handlConsolePackageTabSwitch: PropTypes.func,
    setTabDetails: PropTypes.func,
    isConsoleLoading: PropTypes.bool,
    bookingData: PropTypes.instanceOf(Array),
    originalQtys: PropTypes.instanceOf(Array),
  }),
};

ConsoleBooking.defaultProps = {
  consoleprops: {
    t: () => {},
    setVendorPackageButton: () => {},
    vendorPackageButton: false,
    supplierTab: '',
    consoleBookingColumnsUpdate: [],
    tableData: [],
    pageNumber: '0',
    totalData: '0',
    perPageC: '0',
    swicthPage: () => {},
    setSupplierTab: () => {},
    setSelectedVendorType: () => {},
    totalPage: '0',
    packageOptions: [],
    consolePackageData: [],
    setConsolePackageData: () => {},
    handlConsolePackageTabSwitch: () => {},
    setTabDetails: () => {},
    isConsoleLoading: false,
    bookingData: [],
    originalQtys: [],
  },
};
